"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _training = require("@/api/training");
var _user = require("@/api/user");
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _autoTableHeight = require("@/views/mixins/autoTableHeight");
var _index = _interopRequireDefault(require("../../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TrainingList',
  components: {
    SearchBox: _index.default
  },
  mixins: [_autoTableHeight.autoTableHeight],
  filters: {
    truncate(value, length) {
      return value.substring(0, length) + '......';
    },
    getInternalTitle(value) {
      // console.log('row value', value)
      return typeof value === 'undefined' ? '' : value.title;
    },
    getProducerName(value) {
      return _lodash.default.map(value, function (p) {
        return p.name;
      });
    },
    getProducerStaff(value, staffList) {
      const plist = _lodash.default.map(_lodash.default.flatten(_lodash.default.map(_lodash.default.filter(value, {
        role: 'producer'
      }), function (p) {
        return _lodash.default.filter(staffList, {
          user: p.user
        });
      })), function (n) {
        return n.name;
      }).toString();
      return plist;
    }
  },
  data() {
    return {
      copyDrawer: false,
      tableLoading: false,
      trainingStatus: _lifehikesInitData.trainingStatus,
      myProducedTraining: false,
      countryList: [],
      trainingList: [],
      staffList: [],
      total: 0,
      checked: {
        drawTitle: '',
        id: '',
        title: true,
        internalTitle: true,
        description: true,
        eventDate: true,
        sessions: true,
        sessionDate: true,
        resources: true,
        tags: true,
        webinarInfo: true,
        clientName: true
      },
      query: {
        page: 1,
        limit: 50,
        sort: '-start.utc',
        q: undefined,
        /* title: undefined,*/
        country: undefined,
        publish: undefined,
        staffRole: undefined,
        staffUuid: undefined
      }
    };
  },
  async created() {
    (0, _log.showDebugLog)('Training- list-create', 'created');
    this.$store.dispatch('facets/getInitData', 'en').then(() => {
      this.countryList = this.$store.getters.countries;
    });
    await this.getStaffList();
    await this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    convertlocalTime(utc, timezone) {
      var localtime = (0, _moment.default)(utc).tz(timezone);
      return _moment.default.utc(utc).format('YYYY-MM-DD HH:mm');
    },
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _log.showDebugLog)('Training query', this.query);
      (0, _training.getTrainingList)(token, this.query).then(response => {
        (0, _log.showDebugLog)('Training-Search-response', response);
        this.trainingList = response.data.rows;
        this.total = response.data.count;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('Training-Search-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    getStaffList() {
      this.loading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const query = {
        page: 1,
        limit: 100,
        role: 'otr-digital-producer',
        sort: 'givenName'
      };
      (0, _user.getUserList)(token, query).then(response => {
        this.loading = false;
        this.staffList = response.data.rows.map(s => {
          return {
            user: s.uuid,
            name: `${s.givenName} ${s.familyName}`
          };
        });

        // console.log('Staff List', this.staffList)
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)('GetUserList-api-error', error);
      });
    },
    search(pageNo) {
      this.query.page = pageNo;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      this.query.publish = this.query.publish === '' ? undefined : this.query.publish;
      this.query.country = this.query.country === '' ? undefined : this.query.country;
      this.query.staffUuid = this.query.staffUuid === '' ? undefined : this.query.staffUuid;
      this.getList();
    },
    deleteTraining(id, title) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      var updatedPublishStatus = {
        id: id,
        publish: 'markdelete'
      };
      this.$confirm(`This will delete [ ${title} ]. ${this.$i18n.t('otrTraining.continue')}?`, 'Warning', {
        confirmButtonText: this.$i18n.t('otrTraining.ok'),
        cancelButtonText: this.$i18n.t('otrTraining.cancel'),
        type: 'warning'
      }).then(() => {
        (0, _training.updateTrainingById)(token, id, updatedPublishStatus).then(response => {
          this.search(this.query.page);
          const msg = this.$i18n.t('otrTraining.completeDelete');
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(this, 'Training', `${_lifehikesInitData.userEvent.training.delete}`, oEmail, `Training Id: ${id}`);
        }).catch(error => {
          (0, _log.displayPopupMessage)(error, 'error');
        });

        /*
        deleteTrainingById(token, id).then((response) => {
          this.search(this.query.page)
          const msg = this.$i18n.t('otrTraining.completeDelete')
          displayPopupMessage(msg, 'success')
           writeGaEvent(this, 'Training', `${userEvent.training.delete}`, oEmail, `Training Id: ${id}`)
        }).catch((error) => {
          displayPopupMessage(error, 'error')
          // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
        })
        */
      }).catch(() => {
        const msg = this.$i18n.t('otrTraining.cancelDelete');
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    setMyTraining() {
      // const uuid = utils.getUserUuid()
      if (this.query.staffUuid) {
        this.query.staffRole = 'producer';
        // this.query.staffUuid = uuid
      } else {
        this.query.staffRole = undefined;
        this.query.staffUuid = undefined;
      }
    },
    isExipred(endUtc) {
      var now = _moment.default.utc();
      var end = _moment.default.utc(endUtc);
      return now > end;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$parent.$emit('onSelectionChange', val);
    },
    handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    sort(data) {
      const {
        prop,
        order
      } = data;
      if (prop === 'title') {
        order === 'ascending' ? this.query.sort = '+title' : this.query.sort = '-title';
      }
      if (prop === 'start') {
        order === 'ascending' ? this.query.sort = '+start.utc' : this.query.sort = '-start.utc';
      }
      if (prop === 'end') {
        order === 'ascending' ? this.query.sort = '+end.utc' : this.query.sort = '-end.utc';
      }
      if (prop === 'description') {
        order === 'ascending' ? this.query.sort = '+description' : this.query.sort = '-description';
      }
      if (prop === 'publish') {
        order === 'ascending' ? this.query.sort = '+publish' : this.query.sort = '-publish';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      if (prop === 'internal.title') {
        order === 'ascending' ? this.query.sort = '+internal.title' : this.query.sort = '-internal.title';
      }
      if (prop === 'internal.opportunityNumber') {
        order === 'ascending' ? this.query.sort = '+internal.opportunityNumber' : this.query.sort = '-internal.opportunityNumber';
      }
      this.search(1);
    },
    handleDrawClose(done) {
      this.$confirm('Are you sure you want to stop copy?').then(_ => {
        done();
      }).catch(_ => {});
    },
    copy() {
      this.copyDrawer = false;
      var link = `/training/createfromcopy?` + `fromId=${this.checked.id}&` + `t=${this.checked.title}&` + `it=${this.checked.internalTitle}&` + `d=${this.checked.description}&` + `e=${this.checked.eventDate}&` + `s=${this.checked.sessions}&` + `sd=${this.checked.sessionDate}&` + `r=${this.checked.resources}&` + `tag=${this.checked.tags}&` + `w=${this.checked.webinarInfo}&` + `cn=${this.checked.clientName}`;
      this.$router.push(link);
      /*
       query: { fromId: this.checked.id,
                t: this.checked.title,
                it: this.checked.internalTitle,
                d: this.checked.description,
                e: this.checked.eventDate,
                s: this.checked.sessions,
                sd: this.checked.sessionDate,
                r: this.checked.resources,
                tag: this.checked.tags,
                w: this.checked.webinarInfo,
                cn: this.checked.clientName
                }
              })
              */
    },
    openDrawer(id, title) {
      this.copyDrawer = true;
      this.checked.drawTitle = `Copy a New ILT/VILT from [${title} (${id})]`;
      this.checked.id = id;
    },
    disableVisble(id) {
      this.$refs[id].visible = false;
    }
  }
};